var map = {
	"./americano.jpg": 6970,
	"./apple_tea.jpg": 9668,
	"./beras_kencur.jpg": 4530,
	"./black_tea.jpg": 2340,
	"./butterfly.jpg": 6064,
	"./chicken_wings.jpg": 5527,
	"./chicken_wings_2.jpg": 3395,
	"./coffee_late.jpg": 749,
	"./cokelat.jpg": 8482,
	"./ginger_ale.jpg": 9384,
	"./green_apple.jpg": 5386,
	"./greentea_latte.jpg": 8486,
	"./greentea_lemon_mint.jpg": 8654,
	"./gyoza.jpg": 5187,
	"./hand_cut_fries.jpg": 5553,
	"./ice_taro.jpg": 3578,
	"./kopi_jaya_gula_aren.jpg": 7830,
	"./kopi_susu_jaya.jpg": 6732,
	"./kunir_asam.jpg": 2978,
	"./lemon_tea.jpg": 198,
	"./mango.jpg": 1194,
	"./matcha.jpg": 9313,
	"./minuman_hangat.jpg": 6507,
	"./nachos_pargos.jpg": 7872,
	"./peach.jpg": 6884,
	"./popcorn.jpg": 1328,
	"./potato_wedges.jpg": 7115,
	"./rose_tea.jpg": 2480,
	"./soda_black.jpg": 85,
	"./soda_kopi.jpg": 5230,
	"./soda_leci.jpg": 8522,
	"./soda_sarsa.jpg": 4048,
	"./spring_roll.jpg": 6365,
	"./tahu_bakso.jpg": 544,
	"./thai_tea.jpg": 6558,
	"./yuzu_sweet_punch.jpg": 3197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9557;